import { BriefField } from "@/components/brief/BriefField";

export const BriefContactFields = ({ form, setField }) => (
  <>
    <BriefField label="Your name" num="01">
      <input
        className="brief-field"
        placeholder="Who am I talking to?"
        value={form.name}
        onChange={(event) => setField("name", event.target.value)}
        data-testid="brief-name"
        required
        minLength={2}
        maxLength={120}
        autoComplete="name"
      />
    </BriefField>
    <div className="grid gap-6 sm:grid-cols-2">
      <BriefField label="Email" num="02">
        <input
          type="email"
          className="brief-field"
          placeholder="you@domain.com"
          value={form.email}
          onChange={(event) => setField("email", event.target.value)}
          data-testid="brief-email"
          required
          maxLength={254}
          autoComplete="email"
        />
      </BriefField>
      <BriefField label="Phone / WhatsApp" num="03">
        <input
          type="tel"
          className="brief-field"
          placeholder="+91"
          value={form.phone}
          onChange={(event) => setField("phone", event.target.value)}
          data-testid="brief-phone"
          required
          minLength={7}
          maxLength={40}
          autoComplete="tel"
        />
      </BriefField>
    </div>
  </>
);